import React from 'react';
import styled from 'styled-components';

import Button from './Button';

const StyledContainer = styled.div`
  width: 100vw;
  height: calc(100vh - 20px);
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const Results = ({
  showName,
  reset,
  setShowOverlay,
  character: { name, image },
}) => {
  return (
    <StyledContainer>
      <p
        className='show-results'
        style={{
          textAlign: 'center',
          fontFamily: `'Press Start 2P', monospace`,
          fontWeight: 'bold',
          textTransform: 'uppercase',
          color: '#998A8A',
          fontSize: '2rem',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: '300px',
          margin: '0 auto',
          cursor: 'pointer',
        }}
        onClick={() => setShowOverlay(true)}>
        {showName && name}
      </p>
      <div
        style={{ width: '100px', marginTop: '3rem' }}
        className='show-results'>
        <img
          style={{ width: '100%' }}
          src={window.location.origin + image}
          alt={image}
        />
      </div>

      <Button callback={reset} text='Reset' />
    </StyledContainer>
  );
};

export default Results;
